import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import { useTranslation } from 'react-i18next';

import { HeadsetIcon } from '../../utils/icons';
import { roomHasEnded } from './useRtcAudioRoom';
import * as styles from './style';

export default function RtcRoomIndicator({ room }) {
  const { t } = useTranslation();
  if (!room) return null;

  const ended = roomHasEnded(room);
  const label = ended
    ? `${t('rtcRoom.title', { defaultValue: 'Voice connection' })}: ${t('rtcRoom.ended')}`
    : t('rtcRoom.available');
  return (
    <Tooltip title={label}>
      <styles.RoomIndicator
        $ended={ended}
        aria-label={label}
        data-rtc-room-status={ended ? 'ended' : 'active'}
      >
        <HeadsetIcon size={0.58} />
      </styles.RoomIndicator>
    </Tooltip>
  );
}
